import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService, TUIGlobal } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import Icon from "../../../common/Icon.vue";
import SearchDefaultIcon from "../../../../assets/icon/search-default.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isPC = ref<boolean>(TUIGlobal.getPlatform() === "pc");

return { __sfc: true,isPC, TUITranslateService, Icon, SearchDefaultIcon }
}

})